export function initClock() {
    const el = document.getElementById('gh-clock');
    if (!el) return;

    const tick = () => {
        const now = new Date();
        el.textContent = now.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });
    };

    tick();
    setInterval(tick, 1000);
}
